// @flow

import { useTranslator } from '@gandi/translate';

/** Provides a required validation rule
 * and standard translated message */
export const useRequiredRule = (
  required: boolean,
): { required: string } | void => {
  const { __ } = useTranslator();
  return required ? { required: __('This field is required') } : undefined;
};
